import React from "react";
import {PROJECT} from '../../utils/constant';
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import image from "../../assets/logo.png";

const ProjectDescription = () => {
    return <div className='about' id='about'>
        <Container className="project-description" maxWidth="100%" sx={{
            display: 'flex',
            background: `rgba(255, 255, 255,0.7) url(${image})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            objectFit: 'contain',
            backgroundPosition: 'center',
            fetchPriority: 'eager',
            backgroundBlendMode: 'overlay',

        }}>
            <Typography variant="h3" sx={{color: "var(--primary-color)", fontSize: '30px', fontWeight: 'bold', marginTop: '40px', textTransform: 'uppercase', opacity: '1'}} className='section-title'>Concepto</Typography>
            <Typography className='description-text' variant="p">{PROJECT.DESCRIPTION_1}</Typography>
            <Typography className='description-text' variant="p">{PROJECT.DESCRIPTION_2}</Typography>
            <Typography className='description-text' variant="p">{PROJECT.DESCRIPTION_3}</Typography>
        </Container>

    </div>
}

export default ProjectDescription;
